<template>
  <div class="login-page">
    <div style="position: absolute; left:-9999px;"><input type="text"><input type="password"></div>
    <div class="login-page-header">
      <el-row>
        <el-col :span="16">
          <h1><img src="../assets/img/logo-login.png" />{{ $t('menu.h11') }}</h1>
        </el-col>
        <el-col :span="8" class="lan-group">
          <el-button type="text" @click="setlan('zh')" :class="activecn">中文</el-button>
          <el-button type="text" @click="setlan('en')" :class="activeen">English</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="login-page-inner">
      <div class="login-page-left">
        <div class="login-page-left-inner">
          <LoginLeftComponent />
        </div>
      </div>
      <div class="login-page-right">
        <div class="login-form-box">
          <h1>{{ $t('Loginpages.formtitle') }}</h1>
          <div class="login-form-tips">
            <p v-if="chkemailerror">{{ logintips }}</p>
          </div>
          <el-input prefix-icon="iconfont icon-Email" v-model="email" :placeholder="$t('Loginpages.email')"></el-input>
          <div class="login-form-tips">
            <p v-if="chkepassworderror">{{$t('Loginpages.passwd')}}</p>
          </div>
          <el-input prefix-icon="iconfont icon-yaochi" v-model="password" :placeholder="$t('Loginpages.passwd')" show-password></el-input>
          <el-button @click="clickLogin">{{ $t('Loginpages.signin') }}</el-button>
          <el-row class="login-form-checked">
            <el-col :span="12"><el-checkbox class="checked-rememberme" v-model="rememberme">{{ $t('Loginpages.remember') }}</el-checkbox></el-col>
            <el-col :span="12"><router-link to="/ForgetPassword">{{ $t('Loginpages.forget') }}?</router-link></el-col>
          </el-row>
          <p class="login-form-bottom-p">{{ $t('Loginpages.notmember') }}? <router-link to="/Signup">{{ $t('Loginpages.signupforfree') }}</router-link></p>
        </div>
      </div>
    </div>
    <div class="footer-copy">©2018-{{year}} {{ $t('menu.m19') }} <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备19042251号-1</a> <a href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020181207084743000003442607-SAIC_SHOW_310000-2021110415483913206&signData=MEQCICGc0zlTD86t0dl7ZBOz/SiqBAMsToFxCev7t7AJHAayAiB8gKPb23/E7TQONWWrmejlMygrADhEQFhU4piCa5VoEA==" target="_blank"><img src="../assets/img/ico.jpg" /></a></div>
  </div>
</template>

<script>
import LoginLeftComponent from '../components/LoginLeftComponent.vue'
export default {
  components: {
    LoginLeftComponent
  },
  data(){
    return{
      email: '',
      password: '',
      chkemailerror: false,
      chkepassworderror: false,
      rememberme: false,
      logintips: '',
      activecn: '',
      activeen: '',
      year: this.moment(new Date()).format('YYYY')
    }
  },

  mounted(){

    if(localStorage.getItem("localeLanguage")=='zh'){
      this.activecn = 'activecn'
      this.activeen = ''
    }
    if(localStorage.getItem("localeLanguage")=='en'){
      this.activecn = ''
      this.activeen = 'activeen'
    }

    /**
     * 获取用户保存的密码
     */
    if(localStorage.getItem("loginemail")&&localStorage.getItem("loginpasswd")){
      this.email = JSON.parse(localStorage.getItem("loginemail")).val
      this.password = JSON.parse(localStorage.getItem("loginpasswd")).val
      this.rememberme = true
    }

  },

  methods: {

    setlan: function(lan){
      let that = this
      window.localStorage.setItem('localeLanguage', lan)
      that.$i18n.locale = lan
      if(lan == 'zh'){
        that.activecn = 'activecn'
        that.activeen = ''
      }
      if(lan == 'en'){
        that.activecn = ''
        that.activeen = 'activeen'
      }
    },

    clickLogin: function(){
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/user/login';
      let dataLogin = {
        account: that.email,
        password: btoa(that.password),//Base64加密：btoa(str)；解密：atob(base64)
      }
      console.log(dataLogin)
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(dataLogin),
        contentType: "application/json",
        success: function(data) {
          if(data.code === 200){
            that.$router.push({ path: "/Home" })
            that.setLocalStorage('key', data.data.key)
            that.setLocalStorage('token', data.data.token)
            that.setLocalStorage('useraccount', that.email)
            that.setLocalStorage('userinfo', data.data.need_edit_info)

            if(that.rememberme === true){
              that.setLocalStorage('loginemail', that.email)
              that.setLocalStorage('loginpasswd', that.password)
            }
            
            if(that.rememberme === false){
              localStorage.removeItem("loginemail")
              localStorage.removeItem("loginpasswd")
            }

          }else{
            that.logintips = data.error;
            that.chkemailerror = true
          }
          console.log('success', data)
        },
        error: function(response) {
          console.log('error', response)
        }
      })
    },

  }
}
</script>